import React from 'react';
import { Head } from 'react-static';

export default () => {
  const title = 'App | Northwestern Mutual';
  const description = 'Download the Northwestern Mutual app to get fast, easy, and secure access to your accounts. See your policy and investment details, pay premiums, enroll in Autopay, and more. You can even see how much you are spending (and where) with our Cash Flow budgeting tool.';
  const productName = 'App';
  const url = 'https://www.northwesternmutual.com/app/';
  const publisher = 'Northwestern Mutual';

  return (
    <Head>
      <meta name="addsearch-category" content="App" />
      <meta name="keywords" content="App, app download" />
      <meta name="author" content={publisher} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={publisher} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:site" content="@NM_Financial" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content="@NM_Financial" />
      <meta name="twitter:creator:id" content="@NM_Financial" />
      <meta name="twitter:card" content="summary_large_image" />

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "${productName}",
            "description": "${description}",
            "publisher":
            {
              "@type": "FinancialService",
              "name": "${publisher}"
            },
            "url": "${url}"
          }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "ContactPoint",
            "contactType": "General Questions",
            "telephone": "+1-866-950-4644",
            "name": "${productName}",
            "description": "${description}"
          }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "ContactPoint",
            "contactType": "Corporate Headquarters",
            "telephone": "+1-414-271-1444",
            "name": "${productName}",
            "description": "Northwestern Mutual Corporate Headquarters"
          }`}
      </script>
    </Head>
  );
};
